module.exports = __webpack_public_path__ + "assets/img/icon_user14.5fe92673.png";